import axios from "axios";
import Lightbox from 'vue-easy-lightbox';
import Vue from 'vue'
import VueAxios from "vue-axios";
import VueHead from 'vue-head'

import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'

import Root from './plugins/root'


require('@/assets/styles/global.scss')


// Add Libs/Components
Vue.use(Lightbox)
Vue.use(Root)
Vue.use(VueAxios, axios)
Vue.use(VueHead)

// Setup Application
Vue.config.productionTip = false

new Vue({
    el: "#app",
    i18n,
    router,
    store,
    render: h => h(App)
})

// window.snapSaveState = () => {
//     document.querySelector('#root').setAttribute('data-server-rendered', 'true')
// };

store.$i18n = i18n
